import React, { Component } from "react";

class Contact extends Component {
    render() {
        return(
            <div className="d-flex flex-column my-auto justify-convent-center align-items-center">
                Contact!
            </div>
        );
    }
}

export default Contact;